/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */

import { withStyles } from '@material-ui/core';

import { Box, Grid } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import ListingInfoCard from './listingInfoCard.component';
import ProgramInfoCard from './programInfoCard.component';
import PropTypes from 'prop-types';
import PropertyInfoCard from './propertyInfoCard.component';
import React from 'react';
// import SummaryCard from '../summaryCard.component';
import { SERVICE_IDS } from 'modules/enumerations/enumerationIds';
// import ServiceStatusStepper from '../serviceStatus.component';
import PreferredAgentCard from './preferredAgentCard.component';
import MortgageInfoCard from './homesaleMortgageInfoCard.component';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const PrimaryInfo = props => {
  const {
    details,
    id,
    isReadOnly,
    enumerations,
    emailTemplates,
    authCommentRegardingTypes,
    authCommentServiceTypes,
    history,
    vendors,
    brokerAgents,
    isLoadingModal,
    isOnHold
  } = props;

  const inspectionTypes =
    enumerations && enumerations.allEnums && enumerations.allEnums.inspectionTypes && enumerations.allEnums.inspectionTypes.length > 0
      ? enumerations.allEnums.inspectionTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const equityTypes =
    enumerations &&
    enumerations.allEnums &&
    enumerations.allEnums.homesaleProgramTypes &&
    enumerations.allEnums.homesaleProgramTypes.length > 0
      ? enumerations.allEnums.homesaleProgramTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const listingInfo = details?.homesale?.listings && details?.homesale?.listings[0] ? details?.homesale?.listings[0] : null;
  const homesaleId = details?.homesale?.homesaleInfo?.homesaleId;

  const vendorOptions = React.useMemo(() => {
    const hs = details?.homesale;

    const inspectionsVendorIds = (hs?.inspections || []).map(s => s.vendorId).filter(Boolean);

    const vendorIdSet = new Set([...inspectionsVendorIds]);
    const options = Array.from(vendorIdSet)
      .map(vendorId => {
        const v = (vendors || []).find(x => x.vendorId === vendorId);
        if (!v?.officeEmail || !v?.companyName) return null;

        return {
          vendorId: vendorId,
          officeEmail: v.officeEmail,
          companyName: v.companyName
        };
      })
      .filter(Boolean);

    return options;
  }, [details, vendors]);

  const createHomesaleTemplates = () => {
    if (!emailTemplates || emailTemplates.length === 0) return [];

    const homesaleTemplate = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
        !t.containsAppraisals &&
        !t.containsInspections &&
        !t.containsEquity &&
        !t.containsListings &&
        //  !t.containsBuyout &&
        !t.containsResale
    );

    const appraisalTemplates = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
        t.containsAppraisals &&
        !t.containsInspections &&
        !t.containsEquity &&
        !t.containsListings &&
        //   !t.containsBuyout &&
        !t.containsResale
    );

    const inspectionsTemplates = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
        !t.containsAppraisals &&
        t.containsInspections &&
        !t.containsEquity &&
        !t.containsListings &&
        //  !t.containsBuyout &&
        !t.containsResale
    );

    const equityTemplates = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
        !t.containsAppraisals &&
        !t.containsInspections &&
        t.containsEquity &&
        !t.containsListings &&
        // !t.containsBuyout &&
        !t.containsResale
    );

    const listingTemplates = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
        !t.containsAppraisals &&
        !t.containsInspections &&
        !t.containsEquity &&
        t.containsListings &&
        // !t.containsBuyout &&
        !t.containsResale
    );

    // const buyoutTemplates = emailTemplates.filter(
    //   t =>
    //     isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
    //     !t.containsAppraisals &&
    //     !t.containsInspections &&
    //     !t.containsEquity &&
    //     !t.containsListings &&
    //     // t.containsBuyout &&
    //     !t.containsResale
    // );

    const resaleTemplates = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
        !t.containsAppraisals &&
        !t.containsInspections &&
        !t.containsEquity &&
        !t.containsListings &&
        t.containsResale
    );

    const finalList = [...homesaleTemplate];

    const appr = details?.homesale?.appraisalsBmas || [];
    const insp = details?.homesale?.inspections || [];
    const equity = details?.homesale?.equities || [];
    const listing = details?.homesale?.listings || [];
    const resale = details?.homesale?.resaleOffers || [];

    if (appraisalTemplates.length > 0) {
      for (let i = 0; i < appraisalTemplates.length; i++) {
        for (let j = 0; j < appr.length; j++) {
          let displayName = '';
          if (brokerAgents && brokerAgents.length > 0) {
            const agent = brokerAgents.find(a => a.vendorId === appr[j].vendorId);
            displayName = agent ? ` ${agent.companyName} ` : '';
          }
          const newTemp = { ...appraisalTemplates[i], selectedSegmentServiceId: appr[j].homesaleAppraisalId, displayName: displayName };
          finalList.push(newTemp);
        }
      }
    }

    if (inspectionsTemplates.length > 0) {
      for (let i = 0; i < inspectionsTemplates.length; i++) {
        for (let j = 0; j < insp.length; j++) {
          let displayName = inspectionTypes.find(t => t.id === insp[j].inspectionTypeId)?.title || '';
          const newTemp = { ...inspectionsTemplates[i], selectedSegmentServiceId: insp[j].homesaleInspectionId, displayName: displayName };
          finalList.push(newTemp);
        }
      }
    }

    if (equityTemplates.length > 0) {
      for (let i = 0; i < equityTemplates.length; i++) {
        for (let j = 0; j < equity.length; j++) {
          const e = equity[j].equityInfo;
          if (!e) continue;
          let displayName = equityTypes.find(t => t.id === e.equityTypeId)?.title || '';
          const newTemp = { ...equityTemplates[i], selectedSegmentServiceId: equity[j].homesaleEquityId, displayName: displayName };
          finalList.push(newTemp);
        }
      }
    }

    if (listingTemplates.length > 0) {
      for (let i = 0; i < listingTemplates.length; i++) {
        for (let j = 0; j < listing.length; j++) {
          let displayName = '';
          let broker = brokerAgents && brokerAgents.length > 0 ? brokerAgents.find(a => a.vendorId === listing[j].brokerId) : null;
          if (broker) {
            displayName = ` ${broker.companyName} `;
          }
          const newTemp = { ...listingTemplates[i], selectedSegmentServiceId: listing[j].homesaleListingId, displayName: displayName };
          finalList.push(newTemp);
        }
      }
    }

    if (resaleTemplates.length > 0) {
      for (let i = 0; i < resaleTemplates.length; i++) {
        for (let j = 0; j < resale.length; j++) {
          const r = resale[j].homesaleResaleOffer;
          if (!r) continue;
          let displayName = '';
          let broker = brokerAgents && brokerAgents.length > 0 ? brokerAgents.find(a => a.vendorId === resale[j].brokerId) : null;
          if (broker) {
            displayName = ` ${broker.companyName} `;
          }
          const newTemp = { ...resaleTemplates[i], selectedSegmentServiceId: resale[j].homesaleResaleOfferId, displayName: displayName };
          finalList.push(newTemp);
        }
      }
    }
    return finalList;
  };

  const [validTemplates, setValidTemplates] = React.useState(() => createHomesaleTemplates());

  React.useEffect(() => {
    setValidTemplates(createHomesaleTemplates());
  }, [emailTemplates, details.sentEmailTemplates]);

  return (
    <Box>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} xl={8} rowSpacing={2}>
          <ProgramInfoCard homesale={details.homesale} id={id} isReadOnly={isReadOnly || isLoadingModal} isOnHold={isOnHold} />
          <Box sx={{ paddingTop: '16px' }}>
            <PropertyInfoCard homesale={details.homesale} id={id} isReadOnly={isReadOnly || isLoadingModal} enumerations={enumerations.allEnums} />
          </Box>
        </Grid>
        <Grid item xs={12} xl={4} rowSpacing={2}>
          <AuthServiceGlobalEmailCardComponent
            authId={id}
            communication={details.authorizationDetails}
            emailTemplates={emailTemplates}
            serviceId={SERVICE_IDS.HOME_SALE_SERVICE_ID}
            authCommentServicesEnum={authCommentServiceTypes}
            authCommentRegardingEnum={authCommentRegardingTypes}
            authSentTemplates={details.sentEmailTemplates}
            history={history}
            selectedAuthServiceId={homesaleId}
            vendorOptions={vendorOptions}
            allVendorOptions={vendors}
            selectedSegmentServiceId={homesaleId}
            serviceTemplates={validTemplates}
          />
          <Box sx={{ paddingTop: '16px' }}>
            <ListingInfoCard
              homesaleInfo={details.homesale}
              listingInfo={listingInfo}
              id={id}
              isReadOnly={isReadOnly || isLoadingModal}
              enumerations={enumerations}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <PreferredAgentCard
              homesale={details.homesale}
              id={id}
              isReadOnly={isReadOnly || isLoadingModal}
              enumerations={enumerations.allEnums}
              brokerAgents={brokerAgents}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <MortgageInfoCard
              homesaleId={details.homesale?.homesaleInfo?.homesaleId}
              homesaleMortgages={details.homesale?.mortgages || []}
              isReadOnly={isReadOnly || isLoadingModal}
              authorizationId={id}
              enumerations={enumerations.allEnums}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

PrimaryInfo.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(withStyles(styles), connect(mapStateToProps, {}))(PrimaryInfo);
